import { Button } from '@/React/Shared/Component/Button'
import { Card } from '@/React/Shared/Component/Card'
import { IconNameEnum } from '@/React/Shared/Component/Icon'
import type { GeneratedBusinessName } from '@/Shared/AutoGenerated/Main'
import { UrlFactory } from '@/Shared/Url/UrlFactory'

interface BusinessNameGeneratorSuggestedNameCardProps {
    generatedBusinessName: GeneratedBusinessName
    displayIndex: number
    previewUrl: string
}

export function BusinessNameGeneratorSuggestedNameCard({
    generatedBusinessName,
    displayIndex,
    previewUrl,
}: BusinessNameGeneratorSuggestedNameCardProps) {
    const formattedIndex = String(displayIndex).padStart(2, '0')

    return (
        <Card.Container shouldHighlightOnHover>
            <Card.Content className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex-1 space-y-1">
                    <span className="font-mono text-xs font-medium text-gray-400">
                        {formattedIndex}
                    </span>

                    <h2 className="text-lg font-bold tracking-tight text-gray-900 sm:text-xl">
                        {generatedBusinessName.businessName}
                    </h2>

                    <p className="text-sm leading-relaxed text-gray-500">
                        {generatedBusinessName.businessTagline}
                    </p>
                </div>

                <div className="shrink-0 pt-2 sm:pt-0">
                    <Button
                        as="a"
                        href={previewUrl}
                        color="primary"
                        iconName={IconNameEnum.ArrowRight}
                        iconRight
                        className="w-full sm:w-auto"
                    >
                        Preview Booking Page
                    </Button>
                </div>
            </Card.Content>
        </Card.Container>
    )
}
